export default __webpack_public_path__ + "static/video-2d556231246060260132d76f6818286d.mp4";